import React, { Component } from "react";
import { Link } from "react-router-dom";
import OHAILogo from "../../../assets/images/oh/OHAI-Logo.png";
import buildIcon from "../../../assets/images/hotel-services.png";
import keyIcon from "../../../assets/images/famicons_key-outline.png";
import headphoneIcon from "../../../assets/images/streamline-cyber_headphone.png";
import messageFloaticon from "../../../assets/images/message-float-icon.png";
import TextField from "@mui/material/TextField";
import PhoneInput from "react-phone-input-2";
import SpinnerLoader from "../common/SpinnerLoader";
import ReCAPTCHA from "react-google-recaptcha";
import { Modal } from "react-bootstrap";

class CommonFooterNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openVirtualTourPopup: false,
      first_name: "",
      last_name: "",
      email: "",
      errors: {},
      errors: {
        email: "",
        first_name: "",
        last_name: "",
      },
    };
  }

  openVirtualTour = (val = false) => {
    this.setState({ openVirtualTourPopup: true });
  };

  closeVirtualTour = () => {
    this.setState({ openVirtualTourPopup: false });
    this.setState({
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
    });
    this.setState({
      errors: {
        email: "",
        phone_number: "",
        first_name: "",
      },
    });
  };

  changeHandlerLease = (event) => {
    let input = this.state.input;
    let value = event.target.value;

    if (event.target.name === "first_name") {
      if (event.target.value.length >= 2) {
        const regex = /^[a-zA-Z0-9 ]*[a-zA-Z ]+[a-zA-Z0-9 ]*$/i;
        var errors = this.state.errors;
        if (regex.test(event.target.value) === false) {
          errors.first_name = "Please enter valid name.";
          this.setState({ errors: errors });
        } else {
          errors.first_name = "";
          this.setState({ errors: errors });
        }
      }
    }
    if (event.target.name === "phone_number") {
      if (event.target.value.length > 8) {
        var errors = this.state.errors;
        errors.phone_number = "";
        this.setState({ errors: errors });
      }
      if (event.target.value.length > 15 || event.target.value.length < 8) {
        var errors = this.state.errors;
        errors.phone_number = "The phone number must be a valid phone number";
        this.setState({ errors: errors });
      }
    }
    if (event.target.name === "email") {
      if (event.target.value.length > 7) {
        const regex =
          /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        var errors = this.state.errors;
        if (regex.test(event.target.value) === false) {
          errors.email = "Please enter valid email.";
          this.setState({ errors: errors });
        } else {
          errors.email = "";
          this.setState({ errors: errors });
        }
      }
    }

    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input });
  };

  render() {
    return (
      <React.Fragment>
        <div className="common-footer-nav">
          <div className="row justify-content-center">
            <div className="col-md-10">
              <div className="row">
                <div className="col-md-4">
                  <figure className="footer-logo">
                    <img src={OHAILogo} alt="Footer Logo" />
                    <p>
                      Homesharing-friendly apartments. Rent a place to live,
                      make money when you're away.
                    </p>
                  </figure>
                </div>
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-4">
                      <h3>Live Here</h3>
                      <li>
                        <a href="/Austin/live-here">Live in Austin, TX</a>
                      </li>
                      <li>
                        <a href="/camdenton-mo/live-here">Live in Camdenton, MO</a>
                      </li>
                      <li>
                        <a href="/east-hampton-ny/live-here">Live in East Hampton, NY</a>
                      </li>
                      <li>
                        <a href="/san-antonio-tx/live-here">Live in San Antonio, TX</a>
                      </li>
                    </div>
                    <div className="col-md-4">
                      <h3>Stay Here</h3>
                      <li>
                        <a href="/Austin/stay-here">Stay in Austin, TX</a>
                      </li>
                      <li>
                        <a href="/camdenton-mo/stay-here">Stay in Camdenton, MO</a>
                      </li>
                      <li>
                        <a href="/east-hampton-ny/stay-here">Stay in East Hampton, NY</a>
                      </li>
                      <li>
                        <a href="/san-antonio-tx/stay-here">Stay in San Antonio, TX</a>
                      </li>
                    </div>
                    <div className="col-md-4">
                      <h3>Quick Links</h3>
                      <li>
                        <a href="/about-us">About Us</a>
                      </li>
                      <li>
                        <a href="/contact">Contact Us</a>
                      </li>
                      <li>
                        <a href="/terms-condition">Terms</a>
                      </li>
                      <li>
                        <a href="/privacy">Privacy</a>
                      </li>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row footer-link-btmbox-row">
            <div className="col-md-4">
              <div className="footer-link-btmbox">
                <figure>
                  <img src={buildIcon} alt="Build Icon" />
                </figure>
                <div className="footer-btm-content">
                  <h5>Interested in Working With Us?</h5>
                  <p>
                    Please submit your information{" "}
                    <a href="/contact/#contactSec">here</a> and
                    a member of our team will reach out shortly.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="footer-link-btmbox">
                <figure>
                  <img src={keyIcon} alt="Build Icon" />
                </figure>
                <div className="footer-btm-content">
                  <h5>Looking to Live in an STR-Friendly Community?</h5>
                  <p>
                    If you're a renter interested in leasing in one of our
                    STR-enabled buildings, please share your details{" "}
                    <a href="/contact/#contactSec">here</a>.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="footer-link-btmbox">
                <figure>
                  <img src={headphoneIcon} alt="Build Icon" />
                </figure>
                <div className="footer-btm-content">
                  <h5>Currently Staying at an OHAI Property?</h5>
                  <p>
                    If you're a traveler or guest, please contact our support
                    team through the OHAI app or text us at{" "}
                    <a href="tel:516-636-7466">516-636-7466</a>.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <a href="#" className="message-float-btn">
            <img src={messageFloaticon} alt="Message Float Icon" />
          </a>
        </div>
        <Modal
          show={this.state.openVirtualTourPopup}
          centered
          className="unitmodal-2 pd-l-0"
          onHide={() => this.closeVirtualTour(true)}
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose float-end"
              onClick={() => this.closeVirtualTour(true)}
            >
              {global.closee}
            </span>
            <section className="middle">
              <div className="container-fluid p-0">
                <section className="reservationBook pd-t-20 pd-b-20">
                  <div className="container pd-b-0">
                    <div className="content">
                      <div className="">
                        <div className="col-12 col-md-12 mg-b-20 col-12 col-md-12 pd-l-0 mg-b-20 d-flex justify-content-start">
                          <h4>Tell me about yourself </h4>
                        </div>
                      </div>
                      <div className="row mobView  justify-content-center pd-l-0 pd-r-0">
                        <div className="col-12">
                          <div className="requestSection">
                            <div className="col-xs-12 col-sm-12 col-md-12 pd-l-15 pd-r-15 mg-b-30">
                              <div className="countryphone">
                                <TextField
                                  id="first_name"
                                  name="first_name"
                                  value={this.state.first_name}
                                  onChange={this.changeHandlerLease}
                                  label="Name"
                                  variant="outlined"
                                  fullWidth
                                  required
                                  error={
                                    this.state.errors.first_name ? true : false
                                  }
                                  helperText={
                                    this.state.errors.first_name
                                      ? this.state.errors.first_name
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-12 pd-l-15 pd-r-15 mg-b-30">
                              <div className="countryphone">
                                <TextField
                                  type="email"
                                  name="email"
                                  value={this.state.email}
                                  onBlur={this.validateEmail}
                                  onChange={this.changeHandlerLease}
                                  id="email"
                                  label="Email"
                                  variant="outlined"
                                  fullWidth
                                  required
                                  className=" textfield"
                                  error={this.state.errors.email ? true : false}
                                  helperText={
                                    this.state.errors.email
                                      ? this.state.errors.email
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-12 pd-l-15 pd-r-15 mg-b-30">
                              <PhoneInput
                                country={global.country}
                                onKeyPress={
                                  global.OnKeyPressEvent.phoneValidation
                                }
                                value={this.state.phone_number}
                                variant="outlined"
                                placeholder=""
                                disableCountryCode={true}
                                disableDropdown={true}
                                autoFormat="true"
                                enableSearch="true"
                                countryCodeEditable="true"
                                className="phoneInput"
                                id="phone_number"
                                name="phone_number"
                                disableSearchIcon
                                searchClass="search-class"
                                searchStyle={{
                                  margin: "0",
                                  width: "97%",
                                  height: "30px",
                                }}
                                error={
                                  this.state.errors.phone_number ? true : false
                                }
                                helperText={
                                  this.state.errors.phone_number
                                    ? this.state.errors.phone_number
                                    : ""
                                }
                                onChange={this.changeHandlerPhone}
                              />

                              {this.state.errors.phone_number ? (
                                <p className="error-message">
                                  {this.state.errors.phone_number}
                                </p>
                              ) : (
                                ""
                              )}
                            </div>
                            {this.state.errorCount2 >= 3 && (
                              <div className="col-xs-12 col-sm-12 col-md-12 pd-l-15 pd-r-15 mg-b-30">
                                {/* Add ReCAPTCHA component */}
                                <ReCAPTCHA
                                  ref={recaptchaRef2}
                                  sitekey={process.env.REACT_APP_SITE_KEY}
                                  onChange={this.onChangeRecaptcha2}
                                  onErrored={this.onErrorRecaptcha2}
                                />
                                {this.state.errors.recaptchaToken2 !== "" ? (
                                  <p className="error-message">
                                    {this.state.errors.recaptchaToken2}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            )}
                            <div className="col-md-12 pd-l-15 pd-r-15 mg-b-0 d-flex justify-content-center">
                              <button
                                onClick={this.saveOrUpdateApplicants}
                                disabled={
                                  this.state.loader ||
                                  (this.state.errorCount2 >= 3 &&
                                    !this.state.isValidRecaptcha2) // Disable if loader active or recaptcha not valid
                                }
                                className="w-100"
                              >
                                Next &nbsp;
                                {this.state.loader ? (
                                  <>
                                    <SpinnerLoader />
                                  </>
                                ) : (
                                  ""
                                )}
                              </button>
                              {/* <a
                                href={
                                  "https://calendly.com/orion-haus/discovery"
                                }
                              >
                                {" "}
                                <button
                                  hidden
                                  className="w-100"
                                  id="virtual-tour-button"
                                >
                                  Confirm
                                </button>
                              </a> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </section>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

export default CommonFooterNav;
